/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import { checkAuth } from "../../../Utils/CheckAuthentication";
import { TOKEN_KEY } from "../../../Utils/Constants";
import { baseUrl } from "../../../shared/baseUrl";
import { createNotification } from "../../Common/CreateNotification";
import ItemList from "../../Common/Item/ItemList";
import NoItems from "../../Common/NoItems";
import ShimmerList from "../../Common/Shimmer/ShimmerList";
import EditProductModal from "./EditProductModal";

const AllProducts = ({ url, cityOption, categoryOption, uploadedImages, searchId, isAdded, onProductEdited, isApproved = 0, getTotalItem }) => {

    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const [product, setProduct] = useState(null);
    const [images, setImages] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);


    useEffect(() => {
        var input = document.getElementById(searchId);

        input.addEventListener('click', function () {
            window.scrollTo(0, input.offsetTop - 80);
        });

    }, [searchId])

    const getProducts = useCallback(async () => {
        setIsLoading(true);
        await fetch(baseUrl + `${url}${searchTerm.length > 0 ? `?search=${searchTerm}` : ''}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': localStorage.getItem(TOKEN_KEY) !== null ? 'Bearer ' + JSON.parse(localStorage.getItem(TOKEN_KEY)).token : null
            },
        })
            .then((res) => checkAuth(res))
            .then((res) => {
                if (res.success) {
                    setProducts(res.data.data);
                    isApproved === 1 && getTotalItem(res.overview);

                }
                else {
                    createNotification('error', res.message);
                }
                setIsLoading(false);
            })
            .catch((e) => {
                setIsLoading(false);
                createNotification('error', e.message);
            })
    }, [getTotalItem, isApproved, searchTerm, url])

    useEffect(() => {
        getProducts();
    }, [searchTerm, isAdded])

    return (
        <>
            <input readOnly={products.length <= 3} value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value) }} id={searchId} className='input-field mb-3' placeholder='Search Your Items . . .' />
            <div className='sc-acc-content'>
                {isLoading ? Array(5).fill().map((_, index) =>
                    <ShimmerList key={index} />
                ) :
                    products.length > 0 ?
                        products.map((product, index) => {
                            return (
                                <ItemList isApproved={isApproved} onProductEdit={(product, images) => { setIsEditModalOpen(true); setProduct(product); setImages(images); }} product={product} key={index} />
                            );
                        }) :
                        <NoItems />
                }
                {product !== null && <EditProductModal isApproved={isApproved} onEdited={() => { onProductEdited(); }} productImages={images} cityOption={cityOption} categoryOption={categoryOption} uploadedImages={uploadedImages} product={product} isOpen={isEditModalOpen} onClose={() => { setIsEditModalOpen(false) }} />}

            </div>

        </>

    );
}

export default AllProducts;